// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type PageOnboardingNavFragment = {
  __typename?: "Organization";
  planInfo: {
    __typename?: "OrganizationPlanInfo";
    id: string;
    activeSubscription: boolean;
    trialEndsAt?: number | null;
  };
  onboardingProgress: {
    __typename?: "OrganizationOnboardingProgress";
    id: string;
    integratedCollector: boolean;
    integratedLogInsights: boolean;
    integratedExplain: boolean;
    lastIntegratedServer?: {
      __typename?: "Server";
      id: string;
      humanId: string;
    } | null;
  };
};

export const PageOnboardingNavFragmentDoc = gql`
  fragment PageOnboardingNav on Organization {
    planInfo {
      id
      activeSubscription
      trialEndsAt
    }
    onboardingProgress {
      id
      integratedCollector
      integratedLogInsights
      integratedExplain
      lastIntegratedServer {
        id
        humanId
      }
    }
  }
`;
